import { emit } from '../../platform/analytics/analytics'
import type { InsightSeverity } from '../insights/insightsWire'

/** Counts and enums only — never an amount, an account name or a member name. */
export function emitOverviewViewed(widgetCount: number): void {
  emit('overview_viewed', { widget_count: widgetCount })
}

/** `no_accounts` is the page-level empty; `no_transactions` is a widget-level one (R8). */
export function emitOverviewEmpty(reason: 'no_accounts' | 'no_transactions'): void {
  emit('overview_empty_shown', { reason_code: reason })
}

/** The first insight's severity (a closed set) and how many the server sent. Never its text. */
export function emitInsightShown(severity: InsightSeverity, count: number): void {
  emit('insight_shown', { kind: 'category_anomaly', severity, insight_count: count })
}

export function emitInsightsEmpty(): void {
  emit('insights_empty_shown', {})
}
